<template>
  <section>
    <div class="row m-4">
      <div class="col-md-8">
        <TbFilaURA
          :queues="queuesUra"
          @open-conversa="handleOpenConversa"
          @delete-item="handleDelete"
          @open-modal-transf="handleOpenModalTransf"
        />
        <ModalTransferencia ref="modalTransferencia" :valueClient="dadoClient" />
        <TbFilaAtendimento
          :queues="queuesAwait"
          :user-chat-queues="userChatQueues"
          @open-conversa="handleOpenConversa"
          @delete-item="handleDelete"
          @open-modal-transf="handleOpenModalTransf"
        />
        <TbFilaAndamento
          :queues="queuesAttend"
          :users="users"
          :user-chat-queues="userChatQueues"
          @open-conversa="handleOpenConversa"
          @delete-item="handleDelete"
          @open-modal-transf="handleOpenModalTransf"
        />
      </div>

      <div class="col-md-4 p-0">
        <TbFilaDetail class="m-2" :detail="detailQueues" />
        <GraficoRespondids class="m-2" />
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <TbUsers ref="tbUsers"/>
      </div>
      <div class="col-md-4">
        <GraficoOcupacaoAgent/> 
      </div>
    </div>
  </section>
</template>

<script>
import { mapMutations } from 'vuex';
import TbUsers from "./components/TbUsers";
import GraficoRespondids from "./components/GraficoRespondids";
import GraficoOcupacaoAgent from "./components/GraficoOcupacaoAgent";
import TbFilaAtendimento from "./components/TbFilaAtendimento";
import TbFilaURA from "./components/TbFilaURA";
import TbFilaAndamento from "./components/TbFilaAndamento";
import TbFilaDetail from "./components/TbFilaDetail";
import ModalTransferencia from '../../components/newScreen/mensagem/ModalTransferencia.vue';

const socket = require('./../../modules/realtime/service/service');
const meuAvatar = '/imgs/icons/person.svg';

export default {
  name: "RealtimeApp",
  components: {
    TbFilaAtendimento,
    TbFilaURA,
    TbFilaAndamento,
    TbFilaDetail,
    GraficoOcupacaoAgent,
    GraficoRespondids,
    TbUsers,
    ModalTransferencia
  },
  data(){
    return{
      dadoClient: '',
      queuesAttend: [],
      queuesAwait: [],
      queuesUra: [],
      detailQueues: [],
      users: [],
      userChatQueues: [],
      _onQueueAttend: null,
      _onQueueAwait: null,
      _onQueueUra: null,
      _onQueueDetail: null,
      _onNewEntryRealtime: null,
      _onConnect: null,
    }
  },
  async mounted(){
    const [{ data: users }, { data: userQueues }] = await Promise.all([
      axios.get('/realtime/listUsers'),
      axios.get('/user-chat-queues'),
    ]);
    this.users = users || [];
    this.userChatQueues = userQueues || [];

    socket.connection.emit('realtime:join');

    this._onQueueAttend = (obj)=>{ this.queuesAttend = obj.queues || [] };
    this._onQueueAwait  = (obj)=>{ this.queuesAwait  = obj.queues || [] };
    this._onQueueUra    = (obj)=>{ this.queuesUra    = obj.queues || [] };
    this._onQueueDetail = (obj)=>{ this.detailQueues = obj.queues || [] };

    this._onNewEntryRealtime = (data)=>{
      const key = Object.keys(data)[0];
      const msgs = data[key]?.msgs || [];
      const avatar = data[key]?.avatar;
      const operador = data[key]?.operador;

      const objReturn = [];
      const dataCheck = [];
      msgs.forEach((msg)=>{
        const dt = String(msg.data).trim().split(" ");
        const sepData = { data: dt[0], hora: dt[1] };
        let exibirData = '';
        if(!dataCheck.includes(sepData.data)){
          dataCheck.push(sepData.data);
          exibirData = sepData.data;
        }
        objReturn.push({
          isProprio: msg.type,
          exibirData,
          data: sepData.data,
          hora: sepData.hora,
          mensagem: msg.mensagem,
          avatar: msg.isProprio ? meuAvatar : avatar,
          idOperador: operador
        });
      });
      this.setUserRealtimeData(objReturn);
    };

    socket.connection.on('queueAttend', this._onQueueAttend);
    socket.connection.on('queueAwait',  this._onQueueAwait);
    socket.connection.on('queueUra',    this._onQueueUra);
    socket.connection.on('queueDetail', this._onQueueDetail);
    socket.connection.on('newEntryRealtime', this._onNewEntryRealtime);

    this._onConnect = ()=> socket.connection.emit('realtime:join');
    socket.connection.on('connect', this._onConnect);
  },
  beforeDestroy(){
    socket.connection.emit('realtime:leave');
    const off = socket.connection.off ? 'off' : 'removeListener';
    if (this._onQueueAttend) socket.connection[off]('queueAttend', this._onQueueAttend);
    if (this._onQueueAwait)  socket.connection[off]('queueAwait',  this._onQueueAwait);
    if (this._onQueueUra)    socket.connection[off]('queueUra',    this._onQueueUra);
    if (this._onQueueDetail) socket.connection[off]('queueDetail', this._onQueueDetail);
    if (this._onNewEntryRealtime) socket.connection[off]('newEntryRealtime', this._onNewEntryRealtime);
    if (this._onConnect) socket.connection[off]('connect', this._onConnect);
    this._onQueueAttend = this._onQueueAwait = this._onQueueUra = this._onQueueDetail = this._onNewEntryRealtime = this._onConnect = null;
  },
  methods:{
    ...mapMutations(['setUserRealtime','setUserRealtimeData']),
    async handleOpenConversa(idUsers){
      await this.setUserRealtime(idUsers);
      socket.connection.emit('newEntryRealtimeUsers', { idUsers });
    },
    handleDelete({ client, operadorId }){
      const arrayDados = { client, operador: operadorId };
      socket.connection.emit('queueUraDelete', { arrayDados });
    },
    handleOpenModalTransf(dado){
      this.dadoClient = dado;
      this.$refs.modalTransferencia.openModal();
    },
  }
}
</script>

<style scoped>
.toogle-el{
  display:none;
}

.container-align {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
</style>
